import type { QuoteFile, PresentationLibrary } from 'paintscout'
import { getLibraryFileKey } from './get-library-file-key'

export const removeFileFromLibrary = (args: { file: QuoteFile; library: PresentationLibrary }) => {
  const { file, library } = args
  const key = getLibraryFileKey(file)
  if (!key) {
    console.log('Missing Key: Library is for s3/cloudinary items only')
    return null
  }

  const updatedValues = { ...library.values }
  delete updatedValues[key]

  const updatedLibrary: PresentationLibrary = {
    values: updatedValues,
    order: library.order.filter((orderKey) => orderKey !== key)
  }
  return updatedLibrary
}
